import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-bone px-5 py-16 sm:py-24" data-id="element-109" data-mp="1o2lsv5zg4o2z">
      <Reveal className="mx-auto max-w-4xl" data-id="element-110" data-mp="22369pwlsw9tu">
        <div className="flex flex-col items-start gap-7 rounded-3xl border-2 border-ink bg-volt p-8 sm:flex-row sm:p-11" data-id="element-111" data-mp="2223ghi109var">
          <span className="inline-flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border-2 border-ink bg-ink text-volt" data-id="element-112" data-mp="1x28rxl4pdhsv">
            <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-113" data-mp="14g6667ws4w9w" />
          </span>
          <div data-id="element-114" data-mp="1j4k9sl20sori">
            <h2 className="font-display text-2xl leading-tight text-ink sm:text-3xl" data-id="element-115" data-mp="1j52e84yu69ai">
              Garantía «Profe sin estrés» de 7 días
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink/80" data-id="element-116" data-mp="1ebr1xob990b7">
              Probá el material por 7 días. Si sentís que no te ahorra horas de
              laburo o que no se adapta a tus clases, te devolvemos cada peso.
              Sin preguntas y sin vueltas: mandás un mail y listo. El riesgo es
              todo nuestro.
            </p>
            <a href="#faq" className="mt-5 inline-block text-sm font-bold text-ink underline underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-dark" data-id="element-117" data-mp="txkxbcopzo4b">
              Ver la política de reembolso completa
            </a>
          </div>
        </div>
      </Reveal>
    </section>;
}